import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import arrowLeftIcon from "@iconify-icons/lucide/arrow-left";
import { useNavigate } from "react-router-dom";

import AppTopNav from "../layout/header/AppTopNav";
import Footer from "../layout/footer/footer1";
import ContactUs from "../components/contactUs";

/**
 * /contact-us — página de contacto. Rediseñada 2026-09 al look
 * Academy: AppTopNav arriba, hero navy compacto y `<ContactUs>`
 * dentro de un wrapper mx-auto. Sustituye al initialHeader viejo.
 */
const Contact1 = () => {
  const { t } = useTranslation("global");
  const navigate = useNavigate();

  return (
    <>
      <AppTopNav />

      <header
        style={{
          background: "var(--color-ink)",
          color: "#fff",
          padding: "32px 16px 40px",
        }}
      >
        <div className="mx-auto" style={{ maxWidth: 1160 }}>
          <button
            type="button"
            onClick={() => navigate(-1)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              minHeight: 40,
              padding: 0,
              border: 0,
              background: "transparent",
              color: "#DCE4F0",
              fontSize: 14,
              fontWeight: 700,
              cursor: "pointer",
              marginBottom: 8,
            }}
          >
            <Icon icon={arrowLeftIcon} width={18} height={18} aria-hidden="true" />
            {t("common.back", "Volver")}
          </button>
          <h1
            style={{
              fontSize: 32,
              lineHeight: 1.15,
              fontWeight: 800,
              letterSpacing: "-.02em",
              margin: 0,
              /* ACADEMY-34 #6 — ver comentario análogo en about-1.jsx.
                 Rule global de la plantilla vieja pisa el color del
                 padre; forzamos blanco inline. */
              color: "var(--color-surface)",
            }}
          >
            {t("contact.us", "Contáctanos")}
          </h1>
        </div>
      </header>

      <main className="page-content">
        <div className="mx-auto" style={{ maxWidth: 1160, padding: "40px 16px 60px" }}>
          <ContactUs t={t} />
        </div>
      </main>

      <Footer t={t} />
    </>
  );
};

export default Contact1;
